import { IChoiceGroupOption } from "@fluentui/react";
import { SourceTypeEnum } from "../../api/models/source-type-enum";
import { formatMessage } from "../../utils/helpers/LanguageHelper";

export const tableSourceTypeEnumOptions: IChoiceGroupOption[] = [
  {
    ariaLabel: "tagetik_source_checkbox",
    key: SourceTypeEnum.TAGETIK,
    text: formatMessage("cof.base.tagetik"),
  },
  {
    ariaLabel: "excel_source_checkbox",
    key: SourceTypeEnum.EXCEL,
    text: formatMessage("cof.base.microsoftexcel"),
  },
];

export const amountSourceTypeEnumOptions: IChoiceGroupOption[] = [
  {
    ariaLabel: "tagetik_source_checkbox",
    key: SourceTypeEnum.TAGETIK,
    text: formatMessage("cof.base.tagetik"),
  },
  {
    ariaLabel: "tagetik_form_source_checkbox",
    key: SourceTypeEnum.TAGETIK_FORM,
    text: formatMessage("cof.base.tagetikform"),
  },
  {
    ariaLabel: "excel_source_checkbox",
    key: SourceTypeEnum.EXCEL,
    text: formatMessage("cof.base.microsoftexcel"),
  },
];
